import MuiAvatar from "@mui/material/Avatar";
import type { AvatarProps as MuiAvatarProps } from "@mui/material/Avatar";

export type AvatarProps = MuiAvatarProps;

export function Avatar({ alt = "", src, children, sx }: AvatarProps) {
  return (
    <MuiAvatar alt={alt} src={src} sx={sx}>
      {children}
    </MuiAvatar>
  );
}
